import { useTranslation } from "react-i18next";
import { FiExternalLink } from "react-icons/fi";

interface CardDescriptionProps {
  title: string;
  description: string | null;
  url: string | undefined;
}

const CardDescription = ({ title, description, url }: CardDescriptionProps) => {
  const { t } = useTranslation();

  if (!title && !description) return null;

  return (
    <section className="card card-side bg-white/80 backdrop-blur-sm border border-white/50 shadow-lg hover:shadow-xl transition-all duration-300 m-3 rounded-2xl w-full">
      <div className="card-body p-4 flex flex-col justify-between min-h-[120px]">
        <div>
          <h2 className="card-title text-navy-800 text-lg font-semibold tracking-tight line-clamp-1">
            {title}
          </h2>
          <p className="text-navy-500 text-sm leading-relaxed mt-2 line-clamp-2">
            {description}
          </p>
        </div>
        <div className="card-actions justify-end mt-3">
          <a 
            href={url} 
            target="_blank" 
            rel="noopener noreferrer"
            className="btn btn-primary btn-sm gap-2 rounded-full px-4 hover:scale-105 transition-transform whitespace-nowrap"
          >
            <span>{t("button.cardDescription")}</span>
            <FiExternalLink className="w-3.5 h-3.5 flex-shrink-0" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default CardDescription;
